export default {"src":"/_next/static/media/arrow-down-red.736125de.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};